import { pairwise } from 'rxjs/operators';
import { Component, OnInit, OnDestroy, EventEmitter, Inject } from '@angular/core';
import { ModalAction } from './models';
import { MatSidenav } from '@angular/material/sidenav';
import { TranslateService } from '@ngx-translate/core';
import { AppSettings } from './common/config';
import { LANGUAGE_CONFIG } from './header/languagePicker/language.model';
import { Subscription } from 'rxjs';
import { NavigationEnd, NavigationStart, Router } from '@angular/router';

import { GlobalLoaderFacade } from './sharedServices/globalLoaderFacade/global-loader-facade.service';
import { environment } from '../environments/environment';
import { DOCUMENT } from '@angular/common';
import { CanonicalService } from './services/canonical.service';

declare let window: {
  dataLayer: any;
  scrollTo: (...args: any[]) => void;
};

declare let dataLayer: any;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
})
export class AppComponent implements OnInit, OnDestroy {

  private subscriptions: Subscription[] = [];

  sendMessageModalActions: EventEmitter<string | ModalAction>;

  constructor(
    @Inject(DOCUMENT) private document: Document,
    private translateService: TranslateService,
    private router: Router,
    private loaderService: GlobalLoaderFacade,
    private canonicalService: CanonicalService
  ) {}
  
  ngOnInit() {
    this.enableGoogleAnalytics();

    const browserLang = this.translateService.getBrowserLang();
    
    this.translateService.setDefaultLang('en');

    this.sendMessageModalActions = new EventEmitter<string | ModalAction>();

    if (LANGUAGE_CONFIG.findIndex((item) => item.languageCode === browserLang) >= 0) {
      this.translateService.use(browserLang);
    } else {
      this.translateService.use('en');
    }
    // Set canonical URL on initial page load
    this.updateCanonicalUrl();

    this.subscriptions.push(
            // save or restore scroll position on route change
      this.router.events.pipe(pairwise()).subscribe(([prevRouteEvent, currRouteEvent]) => {
        if (prevRouteEvent instanceof NavigationEnd && currRouteEvent instanceof NavigationStart) {
          this.loaderService.start();
        }
        if (currRouteEvent instanceof NavigationEnd) {
          window.scrollTo(0, 0);
          this.loaderService.complete();
          // Update canonical URL after navigation
          this.updateCanonicalUrl();
        }
      })
    );
  }

  ngOnDestroy() {
    this.subscriptions.forEach((subscription) => subscription.unsubscribe());
  }
  /**
   * Updates the canonical URL for the current page.
   * Removes query parameters and fragments.
   */
  private updateCanonicalUrl(): void {
    const location = this.document.location;
    const canonicalUrl = `${location.origin}${location.pathname}`;

    this.canonicalService.setCanonicalUrl(canonicalUrl);
  }

  enableGoogleAnalytics() {
    const gaScript = document.createElement('script');
    gaScript.src = `https://www.googletagmanager.com/gtag/js?id=${environment.ga_config}`;
    gaScript.async = true;
    document.getElementsByTagName('head')[0].appendChild(gaScript);

    window.dataLayer = window.dataLayer || [];
    function gtag(...args: any[]) {
      args && dataLayer.push(arguments);
    }
    gtag('js', new Date());
    gtag('config', environment.ga_config);
  }
}
